async function exportEnterpriseLayer(id, techniques) {
  // entreprise or pre have techniques and sub techniques
  const techs = techniques.filter((tq) => tq.parent === null);
  let subs = techniques.filter((tq) => tq.parent !== null);
  const parents = subs.map((tq) => tq.parent);
  const teqs = techs.reduce(([noSubs, hasSubs], curr) => {
    const exists = parents.find((parent) => curr.id === parent.id);
    if (exists === undefined) noSubs.push(curr);
    else hasSubs.push(curr);
    return [noSubs, hasSubs];
  }, [[], []]);
  let extraParents = parents.filter((parent) => {
    const exists = teqs.find((teq) => teq.id === parent.id);
    return exists !== undefined;
  });

  let [noSubs, hasSubs] = teqs;
  noSubs = noSubs.map((tq) => ({
    techniqueID: tq.mitre_id,
    score: 100,
    enabled: true,
    showSubtechniques: false
  }));
  hasSubs = hasSubs.map((tq) => ({
    techniqueID: tq.mitre_id,
    score: 100,
    enabled: true,
    showSubtechniques: true
  }));
  extraParents = extraParents.map((tq) => ({
    techniqueID: tq.mitre_id,
    enabled: true,
    showSubtechniques: true
  }));
  subs = subs.map((tq) => ({
    techniqueID: tq.mitre_id,
    score: 100,
    enabled: true,
    showSubtechniques: false
  }));
  let techLayer = [
    ...noSubs,
    ...hasSubs,
    ...extraParents,
    ...subs
  ];
  techLayer = techLayer.sort((a, b) => ((a.techniqueID > b.techniqueID) ? 1 : -1));

  const enterpriseJSON = {
    version: '4.1',
    name: id,
    description: `Techniques mapped to play ${id} in the DWS Pentesting Playbook`,
    domain: 'enterprise-attack',
    gradient: {
      colors: [
        '#8DC63F',
        '#8DC63F'
      ],
      minValue: 0,
      maxValue: 100
    },
    legendItems: [
      {
        label: 'Used at least once',
        color: '#8DC63F'
      }
    ],
    techniques: techLayer
  };
  return enterpriseJSON;
}

async function exportMobileLayer(id, techniques) {
  // mobile matrix has no subtechniques
  let techLayer = techniques.map((tq) => ({
    techniqueID: tq.mitre_id,
    score: 100,
    enabled: true,
    showSubtechniques: false
  }));
  techLayer = techLayer.sort((a, b) => ((a.techniqueID > b.techniqueID) ? 1 : -1));

  const mobileJSON = {
    version: '4.1',
    name: id,
    description: `Techniques mapped to play ${id} in the DWS Pentesting Playbook`,
    domain: 'mobile-attack',
    gradient: {
      colors: [
        '#8DC63F',
        '#8DC63F'
      ],
      minValue: 0,
      maxValue: 100
    },
    legendItems: [
      {
        label: 'Used at least once',
        color: '#8DC63F'
      }
    ],
    techniques: techLayer
  };
  return mobileJSON;
}

export default {
  exportEnterpriseLayer,
  exportMobileLayer
};
